var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconLaptop",
    clipPath: "url(#clip0_539_14349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6478 13.8824H4.11842V5.05882C4.11842 4.47506 4.59348 4 5.17724 4H18.589C19.1728 4 19.6478 4.47506 19.6478 5.05882V13.8824ZM4.8243 13.1765H18.9419V5.05882C18.9419 4.86435 18.7838 4.70588 18.589 4.70588H5.17724C4.98277 4.70588 4.8243 4.86435 4.8243 5.05882V13.1765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7063 19.5295H3.0596C2.72007 19.5295 2.40948 19.3727 2.20795 19.0996C2.00642 18.8264 1.94783 18.4837 2.04771 18.1593L2.06218 18.1209L4.24124 13.1765H19.5254L21.7189 18.1593C21.8184 18.4837 21.7602 18.8267 21.5583 19.0996C21.3564 19.3731 21.0458 19.5295 20.7063 19.5295ZM2.71795 18.3835C2.69148 18.4865 2.7123 18.5942 2.77618 18.6803C2.84324 18.7717 2.94666 18.8236 3.0596 18.8236H20.7063C20.8196 18.8236 20.923 18.7713 20.9904 18.6803C21.0543 18.5942 21.0751 18.4865 21.0487 18.3835L19.0648 13.8824H4.70148L2.71795 18.3835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8831 15.2941H5.88313C5.6883 15.2941 5.53019 15.1364 5.53019 14.9412C5.53019 14.746 5.6883 14.5883 5.88313 14.5883H17.8831C18.0783 14.5883 18.2361 14.746 18.2361 14.9412C18.2361 15.1364 18.0783 15.2941 17.8831 15.2941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.589 16.7059H5.17724C4.98242 16.7059 4.8243 16.5481 4.8243 16.3529C4.8243 16.1578 4.98242 16 5.17724 16H18.589C18.7842 16 18.9419 16.1578 18.9419 16.3529C18.9419 16.5481 18.7842 16.7059 18.589 16.7059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0008 18.1176H9.76548C9.57065 18.1176 9.41254 17.9599 9.41254 17.7647C9.41254 17.5695 9.57065 17.4117 9.76548 17.4117H14.0008C14.1959 17.4117 14.3537 17.5695 14.3537 17.7647C14.3537 17.9599 14.1959 18.1176 14.0008 18.1176Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_14349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptop);
export default __webpack_public_path__ + "static/media/iconLaptop.b008004084c71899caed913d82134a50.svg";
export { ForwardRef as ReactComponent };